module.exports = "/assets/site/images/custom-competition-header-image_3.jpg?9ec31cc747b001f2c4b2ef6fc10657de";